export default __webpack_public_path__ + "static/media/icon-login-email.3d885cd9.webp";